import React from "react";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  arrow: {
    "&:before": {
      border: "1px solid #dadada"
    },
    fontSize: 20,
    color: theme.palette.common.white
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #dadada",
    color: "black",
    fontSize: 12,
    lineHeight: "18px",
    padding: "10px",
    borderRadius: "4px",
    maxWidth:"250px"
  }
}));

export default function ArrowTooltips({ tooltip_text, children }) {
  let classes = useStyles();

  return (
    <Tooltip
      title={tooltip_text}
      arrow
      classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
    >
      {children}
    </Tooltip>
  );
}